<template>
  <lazy-div :load="doInit">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-flex xs4>
              <div class="headline">Policy List</div>
            </v-flex>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-flex xs12>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xl3 lg6 xs6>
                            <v-text-field
                              v-model="filters.polNo"
                              :label="labels.polNo"
                              :error-messages="errors.collect('polNo')"
                              data-vv-name="polNo"
                              :data-vv-as="labels.polNo"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xl3 lg6 xs6>
                            <v-text-field
                              v-model="filters.insdName1"
                              :label="labels.insdName1"
                              :error-messages="errors.collect('insdName1')"
                              data-vv-name="insdName1"
                              :data-vv-as="labels.insdName1"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-data-table
                v-bind:headers="headersPol"
                v-bind:items="items"
                :server-items-length="totalItems"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                :loading="loading"
                :no-data-text="noDataText"
                v-model="selected"
                item-key="id"
              >
                <template v-slot:item="row">
                  <tr>
                    <td class="text-xs-left">{{ row.item.polNo }}</td>
                    <td class="text-xs-left">{{ row.item.endtCnt }}</td>
                    <td class="text-xs-left">{{ row.item.renCnt }}</td>
                    <td class="text-xs-left">{{ row.item.insdName1 }}</td>
                    <td class="text-xs-left">{{ formatDate(row.item.comDate) }}</td>
                    <td class="text-xs-left">{{ formatDate(row.item.expDate) }}</td>
                    <td class="text-xs-left">{{ formatDate(row.item.tranDate) }}</td>
                    <td class="table-action-header">
                      <table-action :rowData="row" query @query="doQuery" :loading="loading"></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </lazy-div>
</template>

<script>
import clone from 'clone'
import * as TableConst from '@/mixins/table'
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/reusable/listMixins'

export default {
  data() {
    return {
      headersPol: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Endt', value: 'endtCnt' },
        { text: 'Ren', value: 'renCnt' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Commencement', value: 'comDate' },
        { text: 'Expiry', value: 'expDate' },
        { text: 'Trans Date', value: 'tranDate' },
        TableConst.tableActionHeader
      ],
      pagination: {
        page: 1,
        sortBy: ['polNo']
      },
      filters: {
        polNo: '',
        insdName1: ''
      },
      labels: {
        polNo: 'Policy No.',
        insdName1: 'Insured Name'
      },
      totalItems: 0,
      toogleArray: [false],
      menu: []
    }
  },
  watch: {
    fetchPolicy: function (value) {
      if (value !== false) {
        this.doInit()
      }
    },
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    pagination: function (value) {
      this.fetchData()
    }
  },
  computed: {
    ...mapGetters(['checkAccess'])
  },
  methods: {
    async doInit() {
      this.fetchData()
    },
    async fetchData() {
      this.loading = true
      const apiURI = this.$store.state.adminInter.intermediary.menu.pagedPolicyList
      if (apiURI) {
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            inter: this.inter,
            interGroupCode: this.interGroupCode
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), clone(this.filters), this.pagination.sortBy, this.pagination.sortDesc)
          )
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.items = []
            data.map((policy) => {
              const convertPolicy = {
                polNo: policy.polNo,
                endtCnt: policy.endtCnt,
                renCnt: policy.renCnt,
                insdName1: policy.insdName1,
                comDate: policy.comDate,
                expDate: policy.expDate,
                tranDate: policy.tranDate
              }
              this.items.push(convertPolicy)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (error) {
          const { data } = error
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.loading = false
          }
        }
      } else {
        this.loading = false
      }
    },
    doQuery(data) {
      this.loading = true
      this.$emit('doQuery', data.item)
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    },
    doClearFilters() {
      this.filters.polNo = null
      this.filters.insdName1 = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      // Reset to page 1
      this.pagination.page = 1
      this.fetchData()
    }
  },
  props: {
    fetchPolicy: {
      type: Boolean,
      default: false
    },
    inter: {
      type: String,
      default: ''
    },
    interGroupCode: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, listMixin, MessageMixin]
}
</script>

<style>
</style>
